import { render } from "./DetallePersonaje.vue?vue&type=template&id=39407994"
import script from "./DetallePersonaje.vue?vue&type=script&lang=js"
export * from "./DetallePersonaje.vue?vue&type=script&lang=js"

import "./DetallePersonaje.vue?vue&type=style&index=0&id=39407994&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__